var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWritingGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8941 17.6041C48.4687 16.1588 46.1797 16.1108 44.6965 17.4595V1.09068C44.6965 0.488189 44.2151 0 43.6209 0H5.07559C4.48158 0 4 0.488189 4 1.09068V47.9093C4 48.5118 4.48158 49 5.07559 49H43.6208C44.215 49 44.6964 48.5118 44.6964 47.9093V28.2981L49.8763 23.0455C49.8792 23.0426 49.8813 23.0396 49.884 23.0368C49.8873 23.0336 49.8909 23.0309 49.8941 23.0277C51.3686 21.5323 51.3686 19.0993 49.8941 17.6041ZM6.15118 46.8186V2.18137H42.5452V19.6323L38.4307 23.8047C38.2682 23.7046 38.0783 23.6461 37.8744 23.6461H10.7216C10.1276 23.6461 9.646 24.1343 9.646 24.7368C9.646 25.3393 10.1276 25.8275 10.7216 25.8275H36.4357L33.9484 28.3497H10.7216C10.1276 28.3497 9.646 28.8379 9.646 29.4404C9.646 30.0429 10.1276 30.5311 10.7216 30.5311H31.7972L29.3098 33.0533H10.7216C10.1276 33.0533 9.646 33.5415 9.646 34.144C9.646 34.7465 10.1276 35.2347 10.7216 35.2347H27.1588L25.1801 37.2411C25.151 37.2707 25.1245 37.3016 25.0994 37.3335C25.0929 37.3419 25.0871 37.3508 25.0807 37.3594C25.0622 37.3844 25.0446 37.4098 25.0285 37.436C25.0225 37.4457 25.0168 37.4559 25.011 37.466C24.9954 37.4932 24.9812 37.5209 24.968 37.549C24.9653 37.555 24.9619 37.5602 24.9591 37.5662L24.7833 37.9639C24.6063 37.834 24.3895 37.7568 24.1546 37.7568H10.7216C10.1276 37.7568 9.646 38.245 9.646 38.8475C9.646 39.45 10.1276 39.9382 10.7216 39.9382H23.9105L22.5256 43.0705C22.5008 43.1267 22.4818 43.1843 22.4669 43.2427C22.186 43.8488 22.2902 44.5947 22.7833 45.0945C23.0877 45.4034 23.4925 45.5734 23.9233 45.5734C24.1678 45.5734 24.4031 45.5168 24.6174 45.4128C24.6722 45.3978 24.7265 45.3799 24.7793 45.356L30.2079 42.8884C30.2135 42.8858 30.2185 42.8824 30.2239 42.8797C30.2523 42.8663 30.2803 42.8516 30.3075 42.8353C30.317 42.8298 30.3265 42.8243 30.3357 42.8184C30.3625 42.8016 30.3884 42.7833 30.414 42.7638C30.4214 42.7579 30.4293 42.7527 30.4368 42.7468C30.4685 42.7212 30.4993 42.6941 30.5285 42.6644L42.5452 30.4792V46.8186H6.15118ZM27.9037 41.5455L25.0972 42.8212C25.0855 42.8086 25.0751 42.7952 25.0631 42.7828C25.0511 42.7706 25.038 42.7601 25.0257 42.7483L26.2838 39.9028L27.9037 41.5455ZM29.768 40.351L27.4618 38.0125L45.2885 19.9356L47.5947 22.2742L29.768 40.351ZM48.8433 20.4552L47.0825 18.6697C47.5447 18.6303 48.0201 18.7887 48.373 19.1466C48.726 19.5043 48.882 19.9867 48.8433 20.4552Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_135",
    x: 0,
    y: 0,
    width: 55,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingGreen);
export default __webpack_public_path__ + "static/media/writing-green.ccdb2ea5aef264eb30180bf35f3c334b.svg";
export { ForwardRef as ReactComponent };